import { render, staticRenderFns } from "./PwaSelfCheck.vue?vue&type=template&id=7165c540&scoped=true"
import script from "./PwaSelfCheck.vue?vue&type=script&lang=js"
export * from "./PwaSelfCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7165c540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7165c540')) {
      api.createRecord('7165c540', component.options)
    } else {
      api.reload('7165c540', component.options)
    }
    module.hot.accept("./PwaSelfCheck.vue?vue&type=template&id=7165c540&scoped=true", function () {
      api.rerender('7165c540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/PwaSelfCheck.vue"
export default component.exports